export class APIResponseModel {
    constructor({
      status,
      message,
      code ,
      data = null,
      dataClass = null
    }) {
      this.status = status;
      this.message = message;
      this.code = code;
      this.data = dataClass && data ? new dataClass(data) : data;
    }
  }